export const API_PATH_ApiTrafficStudyPublishPost = '/services/traffc.studies/apiTrafficStudyPublishPost';
